<script setup>
import { getCurrentInstance } from 'vue';
import { useReviewHistory } from '@/composables/useReviewHistory';

defineProps({
    visible: Boolean,
    item: Object,
});

const emit = defineEmits(['hide']);

const { proxy } = getCurrentInstance();
const $t = proxy.$t;
const { actionLabel, actionSeverityClass, actionIcon } = useReviewHistory();
</script>

<template>
    <Dialog
        :visible="visible"
        @update:visible="(v) => { if (!v) emit('hide'); }"
        modal
        :header="$t('Review History')"
        :style="{ width: '600px' }"
        :breakpoints="{ '640px': '95vw' }"
        @hide="emit('hide')"
    >
        <div v-if="item" class="space-y-3">
            <div
                v-for="log in item.review_logs"
                :key="log.id"
                class="flex gap-3 p-3 rounded-lg border"
                :class="actionSeverityClass(log.action)"
            >
                <i :class="actionIcon(log.action)" class="text-lg mt-0.5 shrink-0"></i>
                <div class="flex-1 min-w-0">
                    <div class="flex items-center justify-between gap-2">
                        <span class="font-medium text-sm">{{ actionLabel(log.action) }}</span>
                        <span class="text-xs opacity-60 shrink-0">{{ new Date(log.created_at).toLocaleString() }}</span>
                    </div>
                    <p v-if="log.message" class="text-sm mt-1 italic">"{{ log.message }}"</p>
                    <p v-if="log.link" class="text-sm mt-1">
                        <a :href="log.link" target="_blank" rel="noopener noreferrer" class="underline font-medium hover:opacity-80">
                            {{ $t('link') }}
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="!item.review_logs?.length" class="text-center py-6 text-surface-500">
                <i class="pi pi-inbox text-3xl mb-2"></i>
                <p>{{ $t('No history yet') }}</p>
            </div>
        </div>
        <template #footer>
            <div class="flex justify-end">
                <Button :label="$t('Close')" severity="secondary" outlined @click="emit('hide')" />
            </div>
        </template>
    </Dialog>
</template>
